/**
 * "Check prices & book" on the vehicle page opens the booking panel. Arriving with #quote opens it too.
 */
module.exports = function () {
    const $panel = $('#quote');
    const $toggle = $('[data-quote-toggle]');

    if (!$panel.length || !$toggle.length)
        return;

    // Bring the button and panel into view (html has smooth scrolling, so use the native scroll)
    const reveal = function () {
        window.scrollTo({top: $toggle.offset().top - 140, behavior: 'smooth'});
    };

    const open = function () {
        $toggle.attr('aria-expanded', 'true');

        if ($panel.hasClass('show'))
            return reveal();

        $panel.one('shown.bs.collapse', reveal).collapse('show');
    };

    $toggle.on('click', function (e) {
        e.preventDefault();
        open();
    });

    if (window.location.hash === '#quote') {
        if ('scrollRestoration' in history)
            history.scrollRestoration = 'manual';

        // Wait a beat after load: the gallery slider and WOW reset the scroll while they set up
        const openSoon = function () { setTimeout(open, 350); };
        document.readyState === 'complete' ? openSoon() : $(window).on('load', openSoon);
    }
};
